import * as yup from "yup";

import * as RHFDateOfBirthValidationRules from "@/utils/validation/schemas/dateOfBirth.RHF";

export const OptionalDateOfBirthFieldSchema = yup.object({
    dateOfBirthDay: RHFDateOfBirthValidationRules.optionalDateOfBirthDay,
    dateOfBirthMonth: RHFDateOfBirthValidationRules.optionalDateOfBirthMonth,
    dateOfBirthYear: RHFDateOfBirthValidationRules.optionalDateOfBirthYear,
    dateOfBirth: RHFDateOfBirthValidationRules.optionalDateOfBirth
});

export const RequiredDateOfBirthFieldSchema = yup.object({
    dateOfBirthDay: RHFDateOfBirthValidationRules.dateOfBirthDay,
    dateOfBirthMonth: RHFDateOfBirthValidationRules.dateOfBirthMonth,
    dateOfBirthYear: RHFDateOfBirthValidationRules.dateOfBirthYear,
    dateOfBirth: RHFDateOfBirthValidationRules.dateOfBirth
});

type OptionalDateOfBirthFormValues = yup.InferType<
    typeof OptionalDateOfBirthFieldSchema
>;

type RequiredDateOfBirthFormValues = yup.InferType<
    typeof RequiredDateOfBirthFieldSchema
>;

export type DateOfBirthFieldValues =
    | OptionalDateOfBirthFormValues
    | RequiredDateOfBirthFormValues;
